import { useCallback } from 'react'
import { ListOnItemsRenderedProps } from 'react-window'

interface InfiniteScrollOptions {
  isLoading: boolean
  hasMore: boolean
  totalItems: number
  onLoadMore: () => void
}

export function useInfiniteScroll({
  isLoading,
  hasMore,
  totalItems,
  onLoadMore,
}: InfiniteScrollOptions) {
  const handleItemsRendered = useCallback(
    ({ overscanStopIndex }: ListOnItemsRenderedProps) => {
      if (
        !isLoading &&
        hasMore &&
        overscanStopIndex >= totalItems - 1
      ) {
        onLoadMore()
      }
    },
    [isLoading, hasMore, totalItems, onLoadMore]
  )

  return { handleItemsRendered }
} 